import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import config from '../config/config.js';
import Loader from "../components/Loader/Loader.jsx";
import GlobalLoader from "../components/Loader/GlobalLoader.jsx";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute.jsx";
import feLog from "../utils/feLog";

const LayoutPrivadas = lazy(() => import("../layouts/LayoutPrivadas/LayoutPrivadas.jsx"));
const Home = lazy(() => import("../pages/Home/Home.jsx"));
const Evaluador = lazy(() => import("../pages/Evaluador/Evaluador.jsx"));
const Evaluado = lazy(() => import("../pages/Evaluado/Evaluado.jsx"));
const Jerarquias = lazy(() => import("../pages/Jerarquias/Jerarquias.jsx"));
const ObjetivosOrganizacionales = lazy(() => import("../pages/ObjetivosOrganizacionales/ObjetivosOrganizacionales.jsx"));
const Login = lazy(() => import("../pages/Login/Login.jsx"));
const Evaluacion = lazy(() => import("../pages/Evaluacion/Evaluacion.jsx"));
const Auditoria = lazy(() => import("../pages/Auditoria/Auditoria.jsx"));
const AuditoriaEvaluador = lazy(() => import("../pages/Auditoria/AuditoriaEvaluador.jsx"));
const Reporte = lazy(() => import("../pages/Reporte/Reporte.jsx"));
const Steps = lazy(() => import("../pages/Steps/Steps.jsx"));
const OlvideContraseña = lazy(() => import("../pages/OlvideContraseña/OlvideContraseña.jsx"));
const RestablecerContraseña = lazy(() => import("../pages/RestablecerContraseña/RestablecerContraseña.jsx"));
const ListadoCalificaciones = lazy(() => import("../pages/ListadoCalificaciones/ListadoCalificaciones.jsx"));
const ActivateAccount = lazy(() => import("../pages/ActivateAccount/ActivateAccount.jsx"));
const Perfil = lazy(() => import("../pages/Perfil/Perfil.jsx"));
const Configuracion = lazy(() => import("../pages/Configuracion/Configuracion.jsx"));
const JerarquiasUsuario = lazy(() =>
  import("../pages/Configuracion/JerarquiasUsuario.jsx").catch((error) => {
    feLog({
      src: "jerarquias-usuario",
      step: "lazy-fail",
      msg: error?.message,
      stack: error?.stack,
      href: window.location.href,
    });
    throw error;
  })
);
const GruposPermisos = lazy(() => import("../pages/Configuracion/GruposPermisos.jsx"));
const ListadoUsuarios = lazy(() => import("../pages/Configuracion/ListadoUsuarios.jsx"));
const NotFound = lazy(() => import("../pages/NotFound/NotFound.jsx"));
const PlantillasObjetivos = lazy(() => import("../pages/PlantillasObjetivos/PlantillasObjetivos.jsx"));
const CompetenciasBlandas = lazy(() => import("../pages/CompetenciasBlandas/CompetenciasBlandas.jsx"));
const TiposValorizacion = lazy(() => import("../pages/TiposValorizacion/TiposValorizacion.jsx"));

export const privateRoutes = [
  { path: "/", element: <Home /> },
  { path: "/evaluador", element: <Evaluador /> },
  { path: "/evaluado", element: <Evaluado /> },
  
  { path: "/evaluacion", element: <Evaluacion /> },
    
  { path: "/listado-calificaciones", element: <ListadoCalificaciones /> },
  { path: "/reporte-general", element: <Reporte /> },
  
  { path: "/auditoria", element: <Auditoria /> },
  { path: "/auditoria-evaluador", element: <AuditoriaEvaluador /> },
  { path: "/jerarquias", element: <Jerarquias /> },
  { path: "/principios-culturales", element: <ObjetivosOrganizacionales /> },
  { path: "/competencias", element: <CompetenciasBlandas /> },
  { path: "/tipos-valorizaciones", element: <TiposValorizacion /> },
  { path: "/steps", element: <Steps /> },
  { path: "/perfil", element: <Perfil /> },
  { path: "/configuracion", element: <Configuracion /> },
  { path: "/configuracion/jerarquias-usuario", element: <JerarquiasUsuario /> },
  { path: "/configuracion/grupos-permisos", element: <GruposPermisos /> },
  { path: "/configuracion/usuarios", element: <ListadoUsuarios /> },
  { path: "/test", element: <Login /> },
];

export default function Rutas() {
  return (
    <BrowserRouter basename={config.URL.BASENAME}>
      <GlobalLoader />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/restablecer-contraseña" element={<OlvideContraseña />} />
          <Route path="/password-reset/:token" element={<RestablecerContraseña />} />
          <Route path="/activate-account/:token" element={<ActivateAccount />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/IA" element={<PlantillasObjetivos />} />

          <Route element={<LayoutPrivadas />}>
            {privateRoutes.map(({ path, element }, i) => (
              <Route 
                key={i} 
                path={path} 
                element={
                  <ProtectedRoute>
                    {element}
                  </ProtectedRoute>
                } 
              />
            ))}
          </Route>
        </Routes>
      </Suspense>

      <ToastContainer 
        position="top-right" 
        autoClose={3000} 
        hideProgressBar={false} 
        newestOnTop={false} 
        closeOnClick 
        rtl={false} 
        pauseOnFocusLoss 
        draggable 
        pauseOnHover 
      />
    </BrowserRouter>
  );
}